import { projectsProjectReferenceCapability } from '@crest/module-projects/contracts/project-reference';
import { projectsProjectRecordPolicyCapability } from '@crest/module-projects/contracts/record-policy';
import { projectsProjectDetailHostCapability } from '@crest/module-projects/contracts/detail-host';
import { projectsProjectDetailLauncherCapability } from '@crest/module-projects/contracts/detail-launcher';
import { projectsImportResolutionCapability } from '@crest/module-projects/contracts/import-resolution';
import { platformMyDayHostCapability, platformOptionalActionProviderHostCapability, platformOptionalFactProviderHostCapability, } from '@crest/platform-contracts/hosts';
import { platformImportResolutionCapability } from '@crest/platform-contracts/import-resolution';
import { defineCrestModule } from '@crest/platform-contracts/modules';
import { tasksChecklistsCapability, tasksLinksCapability, tasksTaskDetailCapability, } from './contracts/tasks-detail.contract.js';
import { tasksFocusCapability, tasksMyDayProjectionCapability, tasksTemplatesCapability, } from './contracts/tasks-focus.contract.js';
import { tasksAssignmentsCapability, tasksCommentsCapability, tasksTasksCapability, } from './contracts/tasks-task.contract.js';
import { tasksNotificationsCapability } from './contracts/tasks-notification.contract.js';
import { tasksInsuranceClaimsActionsCapability, tasksInsuranceClaimsActionsProviderId, } from './contracts/tasks-insurance-claims-actions.contract.js';
import { tasksAssistantContextCapability, tasksAssistantContextProviderId, } from './contracts/tasks-assistant-context.contract.js';
import { tasksWorkflowActionsCapability } from './contracts/tasks-workflow-actions.contract.js';
import { tasksTaskReversalActionsCapability, } from './contracts/tasks-task-reversal-actions.contract.js';
import { tasksNotificationPreferencesImportCapability } from './import/tasks-import.contracts.js';
import { tasksOperationalImportCapability } from './import/tasks-operational-import.contract.js';
export const tasksModuleManifest = defineCrestModule({
    id: 'tasks',
    version: '1.0.0',
    kind: 'business',
    required: false,
    requires: ['platform', 'projects'],
    requiredCapabilities: [
        'platform.tenant-context.v1',
        'platform.request-authority-hold.v1',
        'platform.owner-invocation-receipts.v1',
        'platform.module-access.v1',
        'platform.membership-directory.v1',
        'platform.migration-run-ledger.v1',
        platformImportResolutionCapability,
        'projects.projects.v1',
        projectsProjectReferenceCapability,
        projectsProjectRecordPolicyCapability,
        projectsProjectDetailHostCapability,
        projectsProjectDetailLauncherCapability,
        projectsImportResolutionCapability,
        platformMyDayHostCapability,
        platformOptionalFactProviderHostCapability,
        platformOptionalActionProviderHostCapability,
    ],
    optionalCapabilities: [],
    optionalCapabilityFallbacks: [],
    provides: [
        tasksTasksCapability,
        tasksAssignmentsCapability,
        tasksCommentsCapability,
        tasksFocusCapability,
        tasksTemplatesCapability,
        tasksMyDayProjectionCapability,
        tasksNotificationsCapability,
        tasksTaskDetailCapability,
        tasksChecklistsCapability,
        tasksLinksCapability,
        tasksInsuranceClaimsActionsCapability,
        tasksAssistantContextCapability,
        tasksWorkflowActionsCapability,
        tasksTaskReversalActionsCapability,
        tasksNotificationPreferencesImportCapability,
        tasksOperationalImportCapability,
    ],
    permissions: [
        'tasks.tasks.read-own',
        'tasks.tasks.read-all',
        'tasks.tasks.create',
        'tasks.tasks.update-own',
        'tasks.tasks.update-all',
        'tasks.tasks.cancel',
        'tasks.assignments.manage',
        'tasks.assignments.sign-off',
        'tasks.assignments.override',
        'tasks.comments.create',
        'tasks.checklists.manage',
        'tasks.links.manage',
        'tasks.templates.apply',
        'tasks.focus.read',
        'tasks.focus.manage',
        'tasks.focus.close',
        'tasks.notifications.prepare',
        'tasks.import.execute',
        'tasks.import.rollback',
    ],
    settings: [
        'tasks.copy.work-queue',
        'tasks.work-queue.display',
        'tasks.focus.configuration',
        'tasks.copy.focus',
        'tasks.copy.detail',
        'tasks.copy.my-day',
        'tasks.notifications.configuration',
        'tasks.copy.notifications',
    ],
    copyCatalogs: [
        'tasks.copy.work-queue',
        'tasks.copy.focus',
        'tasks.copy.detail',
        'tasks.copy.my-day',
        'tasks.copy.notifications',
    ],
    events: {
        publishes: [
            'tasks.task-created.v1',
            'tasks.task-updated.v1',
            'tasks.task-signed-off.v1',
            'tasks.task-reopened.v1',
            'tasks.task-cancelled.v1',
            'tasks.task-commented.v1',
            'tasks.checklist-item-added.v1',
            'tasks.checklist-item-updated.v1',
            'tasks.checklist-item-completed.v1',
            'tasks.checklist-item-reopened.v1',
            'tasks.checklist-item-removed.v1',
            'tasks.link-added.v1',
            'tasks.link-removed.v1',
            'tasks.template-applied.v1',
            'tasks.focus-window-created.v1',
            'tasks.focus-item-added.v1',
            'tasks.focus-item-updated.v1',
            'tasks.focus-item-removed.v1',
            'tasks.focus-window-closed.v1',
            'tasks.notification-intent-requested.v1',
        ],
        subscribes: [],
    },
    server: {
        routes: [
            { id: 'tasks.routes.work-queue', priority: 0 },
            { id: 'tasks.routes.detail', priority: 5 },
            { id: 'tasks.routes.focus', priority: 10 },
            { id: 'tasks.routes.my-day-projection', priority: 20 },
            { id: 'tasks.routes.notifications', priority: 30 },
        ],
        jobs: [],
        subscribers: [],
        slots: [{
                id: tasksInsuranceClaimsActionsProviderId,
                requiredCapability: platformOptionalFactProviderHostCapability,
                requiredPermission: 'tasks.tasks.read-all',
                priority: 0,
            }, {
                id: tasksAssistantContextProviderId,
                requiredCapability: platformOptionalFactProviderHostCapability,
                priority: 10,
            }, {
                id: tasksWorkflowActionsCapability,
                requiredCapability: platformOptionalActionProviderHostCapability,
                requiredPermission: 'tasks.tasks.create',
                priority: 20,
            }, {
                id: tasksTaskReversalActionsCapability,
                requiredCapability: platformOptionalActionProviderHostCapability,
                requiredPermission: 'tasks.tasks.cancel',
                priority: 25,
            }],
    },
    web: {
        routes: [
            { id: 'tasks.web.work-queue', priority: 0 },
            { id: 'tasks.web.detail', priority: 5 },
            { id: 'tasks.web.focus', priority: 10 },
            { id: 'tasks.web.notifications', priority: 20 },
        ],
        navigation: [
            { id: 'tasks.navigation.work-queue', priority: 60 },
            { id: 'tasks.navigation.focus', priority: 61 },
            { id: 'tasks.navigation.notifications', priority: 62 },
        ],
        slots: [{
                id: 'tasks.web.settings.focus-configuration',
                priority: 10,
            }, {
                id: 'tasks.web.projects.task-summary',
                priority: 50,
                requiredCapability: projectsProjectDetailHostCapability,
                requiredPermission: 'tasks.tasks.read-own',
            }, {
                id: 'tasks.web.platform.my-day',
                priority: 20,
                requiredCapability: platformMyDayHostCapability,
                requiredPermission: 'tasks.tasks.read-own',
            }, {
                id: 'tasks.web.settings.notification-configuration',
                priority: 20,
            }],
    },
    mobile: { routes: [], slots: [] },
    portal: { routes: [], slots: [] },
    database: {
        schema: 'tasks',
        owns: [
            'tasks.tasks',
            'tasks.task_assignments',
            'tasks.task_comments',
            'tasks.task_activity',
            'tasks.task_commands',
            'tasks.execute_task_command',
            'tasks.task_checklist_items',
            'tasks.task_links',
            'tasks.task_template_instances',
            'tasks.task_detail_events',
            'tasks.task_detail_commands',
            'tasks.execute_task_detail_command',
            'tasks.focus_windows',
            'tasks.focus_items',
            'tasks.focus_commands',
            'tasks.unassigned_completion_commands',
            'tasks.execute_focus_command',
            'tasks.complete_unassigned_task',
            'tasks.notification_preferences',
            'tasks.notification_intents',
            'tasks.get_notification_preferences',
            'tasks.update_notification_preferences',
            'tasks.request_assignment_notification_intents',
            'tasks.prepare_reminder_notification_intents',
            'tasks.workflow_task_origins',
            'tasks.task_workflow_reversal_commands',
            'tasks.task_workflow_reversal_evidence',
            'tasks.ecmascript_trim_v1',
            'tasks.utf16_length_v1',
            'tasks.reject_workflow_origin_mutation',
            'tasks.guard_workflow_reversal_command_mutation',
            'tasks.execute_workflow_create_task',
            'tasks.cancel_workflow_created_task',
            'tasks.notification_preferences_import_runs',
            'tasks.notification_preferences_import_identity_map',
            'tasks.notification_preferences_import_receipts',
            'tasks.notification_preferences_import_changes',
            'tasks.notification_preferences_import_rejects',
            'tasks.notification_preferences_import_rollbacks',
            'tasks.notification_preferences_import_evidence_immutable',
            'tasks.notification_preferences_import_canonical_json',
            'tasks.notification_preferences_import_sha256',
            'tasks.notification_preferences_import_timestamp',
            'tasks.notification_preferences_import_time',
            'tasks.notification_preferences_import_payload_keys',
            'tasks.notification_preferences_import_target_canonical',
            'tasks.notification_preferences_import_canonical',
            'tasks.notification_preferences_import_assert_membership_resolution',
            'tasks.notification_preferences_import_receipt_json',
            'tasks.begin_notification_preferences_import_v1',
            'tasks.quarantine_notification_preferences_import_v1',
            'tasks.apply_notification_preferences_import_v1',
            'tasks.verify_notification_preferences_import_receipt_v1',
            'tasks.rollback_notification_preferences_import_v1',
            'tasks.operational_import_runs',
            'tasks.operational_import_identity_map',
            'tasks.operational_import_receipts',
            'tasks.operational_import_changes',
            'tasks.operational_import_rejects',
            'tasks.operational_import_rollbacks',
            'tasks.operational_import_evidence_immutable_v1',
            'tasks.operational_import_target_canonical_v1',
            'tasks.operational_import_receipt_json_v1',
            'tasks.operational_import_assert_member_v1',
            'tasks.operational_import_assert_project_v1',
            'tasks.begin_operational_import_v1',
            'tasks.quarantine_operational_import_v1',
            'tasks.apply_operational_import_v1',
            'tasks.verify_operational_import_receipt_v1',
            'tasks.complete_operational_import_v1',
            'tasks.rollback_operational_import_v1',
            'tasks.complete_operational_import_rollback_v1',
        ],
        readsThrough: [
            projectsProjectReferenceCapability,
            projectsProjectRecordPolicyCapability,
            'platform.membership-directory.v1',
            'platform.request-authority-hold.v1',
            'platform.owner-invocation-receipts.v1',
            platformImportResolutionCapability,
            projectsImportResolutionCapability,
        ],
        migrations: [
            'tasks.work_queue_foundation',
            'tasks.focus_templates_projection',
            'tasks.notification_preferences_intents',
            'tasks.task_detail_checklists_links',
            'tasks.project-record-access-enforcement',
            'tasks.project-record-access-hold',
            'tasks.complete-owner-authority-hold',
            'tasks.workflow-origin-reversal',
            'tasks.notification-preferences-import',
            'tasks.operational-import',
        ],
    },
    health: ['tasks.database'],
    lifecycle: {
        initialization: { timeoutMs: 5_000, failureBehavior: 'quarantine-module' },
        resources: {
            requestConcurrency: 64,
            jobConcurrency: 0,
            queueBacklogLimit: 0,
            databaseConnectionBudget: 8,
            workerIsolation: 'shared-api',
        },
        disable: {
            data: 'retain',
            clientContributions: 'remove',
            serverRoutes: 'deny-tenant-access',
            scheduledJobs: 'skip',
            events: {
                behavior: 'drop-safe',
                durableCursor: false,
                retentionDays: 0,
                backlogLimit: 0,
                warningAt: 0,
                reconciliationProcedure: null,
                dropSafeReason: 'The golden Tasks slice publishes facts but owns no inbound subscriber.',
            },
            outboundSideEffects: 'suppress-no-retroactive-send',
            inFlight: 'finish-idempotently',
        },
        resume: {
            configuration: 'last-compatible-published',
            healthChecks: ['tasks.database'],
            reconciliationProcedure: null,
            visibility: 'after-health-and-reconciliation',
        },
        uninstall: {
            executableCode: 'remove',
            data: 'retain',
            tombstone: 'retain-immutable',
            destruction: 'separate-explicit-authority',
        },
    },
    retentionPolicy: 'Tasks, checklist/link history, template instances, Focus, comments, notifications, activity, and command evidence remain stored while disabled.',
});
//# sourceMappingURL=tasks.module.js.map